import {SyncUIActDecorator} from '@gongxigames/framework/slotV2/fsm/acts/decorators/SyncUIActDecorator';
import {FeatureEventData, slotStore} from '@gongxigames/framework/slotV2/globals';
import {SlotSettings} from '@gongxigames/framework/slot';

/**
 * As we need such listener in many states of UI FSM and we don't have skip mechanism for this FSM
 * in such way we reuse code, which listen to 'Game.command.round.uiDisabled' event
 */
export function listenUIDisabled(target: SyncUIActDecorator): void {
    const handler = (name: symbol | void) => {
        slotStore.isDisabledUIMode.value = true;
        slotStore.disabledUIModeDataName.value = name ?? undefined;
        target.onExecuted?.();
    };

    target.emitter.on('Game.command.round.uiDisabled', handler);
}

/**
 * As we need such listener in many states of UI FSM and we don't have skip mechanism for this FSM
 * in such way we reuse code, which listen to 'Game.command.round.featureStarted' event
 */
export function listenUIFeatureStarted(target: SyncUIActDecorator, settings: SlotSettings): void {
    const handler = (data: FeatureEventData) => {
        if (!settings.get('autoplayStopWhenAnyBonus')) {
            slotStore.batchUpdate({
                autoplayOptionsBeforeFeature: Object.assign({}, slotStore.autoplayOptions?.value)
            });
        }
        setAutoplaySpinsToZero();
        slotStore.batchUpdate({
            feature_type: data
        });
        slotStore.isDisabledUIMode.value = false;
        target.onExecuted?.();
    };

    target.emitter.on('Game.command.round.featureStarted', handler);
}

export function setAutoplaySpinsToZero(): void {
    const autoplayOptions = slotStore.autoplayOptions.value;

    if (autoplayOptions?.autoplaySpins) {
        autoplayOptions.autoplaySpins = 0;
    }
}
